import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IMetricFieldsChoice, IMetricPrediction } from "@gtmhub/insights/services/auto-fields.service";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { AutoFields, AutoFieldsDTO } from "@webapp/data-story/models/auto-fields-facade.models";
import { AutoFieldsApiService } from "@webapp/data-story/services/auto-fields-facade/auto-fields-api.service";
import { AutoFieldsState } from "@webapp/data-story/services/auto-fields-facade/auto-fields-state.service";
import { AutoInsightsState } from "@webapp/data-story/services/auto-insights-facade/auto-insights-state.service";

@Injectable()
export class AutoFieldsFacade extends BaseFacade<AutoFields, AutoFieldsDTO, AutoFieldsState, AutoFieldsApiService> {
  constructor(state: AutoInsightsState, api: AutoFieldsApiService) {
    super(state, api);
  }

  public getPredictionFromMetric$(title: string): Observable<IMetricPrediction> {
    return this.post$<IMetricPrediction>(
      { title },
      {
        ...new RequestConfig(),
        url: this.apiService.getPredictionFromMetricEndpoint(),
      }
    );
  }

  public sendMetricAnalyticsData$(data: IMetricFieldsChoice): Observable<IMetricFieldsChoice> {
    return this.post$<IMetricFieldsChoice>(data, {
      ...new RequestConfig(),
      url: this.apiService.getMetricPredictionFeedbackEndpoint(),
    });
  }
}
